import React from 'react';
import OrphangeVisit2025 from 'views/OrphangeVisit2025';

const VissionAndMissionPage = () => {
  return <OrphangeVisit2025/>;
};

export default VissionAndMissionPage;